import baseApi, {provideTag} from './baseApi'

const configApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getConfigByKey: build.query({
            query: (key) => {
                return {
                    url: `configs/${key}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Config', result),
        }),
        getConfigsByKeys: build.query({
            query: (keys) => {
                return {
                    url: `configs/keys`,
                    method: 'POST',
                    body: keys,
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Config', result),
        }),
        setConfigByKey: build.mutation({
            query: (key, data) => {
                return {
                    url: `configs/${key}`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Config'],
        }),
        getSettings: build.query({
            query: () => {
                return {
                    url: 'configs/settings',
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: ['Config'],
        }),
        setSettings: build.mutation({
            query: (data) => {
                return {
                    url: 'configs/settings',
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Config'],
        }),
    }),
    overrideExisting: false,
})

export default configApi

export const {
    useGetConfigByKeyQuery,
    useSetConfigByKeyMutation,
    useGetSettingsQuery,
    useSetSettingsMutation,
    useGetConfigsByKeysQuery,
} = configApi
